import { axiosInstance } from "../../utils";

const actions = {
    FETCH_PROMOTIONS_REQUESTED: 'FETCH_PROMOTIONS_REQUESTED',
    FETCH_PROMOTIONS_SUCCEEDED: 'FETCH_PROMOTIONS_SUCCEEDED',
    FETCH_PROMOTIONS_FAILED: 'FETCH_PROMOTIONS_FAILED',

    FETCH_PROMOTION_REQUESTED: 'FETCH_PROMOTION_REQUESTED',
    FETCH_PROMOTION_SUCCEEDED: 'FETCH_PROMOTION_SUCCEEDED',
    FETCH_PROMOTION_FAILED: 'FETCH_PROMOTION_FAILED',

    DELETE_PROMOTION_REQUESTED: 'DELETE_PROMOTION_REQUESTED',
    DELETE_PROMOTION_SUCCEEDED: 'DELETE_PROMOTION_SUCCEEDED',
    DELETE_PROMOTION_FAILED: 'DELETE_PROMOTION_FAILED',

    removePromotion: (id = undefined) => {
        return {
            type: actions.DELETE_PROMOTION_REQUESTED,
            payload: id
        }
    },

    deletePromotion: async (id = undefined) => {
        const url = `offers/`+id;

        try {
            const response = await axiosInstance.delete(url);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    fetchPromotions: (params = undefined) => {
        return {
            type: actions.FETCH_PROMOTIONS_REQUESTED,
            payload: params
        }
    },

    fetchPromotion: (id = undefined) => {
        return {
            type: actions.FETCH_PROMOTION_REQUESTED,
            payload: id
        }
    },

    getPromotions: async (params = undefined) => {
        const url = `offers`;

        try {
            const promotions = await axiosInstance.get(url,{ params });
            return promotions.data;
        } catch (error) {
            throw error;
        }
    },

    getPromotion: async (promotionId = undefined) => {
        const url = `offers/`+promotionId;

        try {
            const promotion = await axiosInstance.get(url);
            return promotion.data;
        } catch (error) {
            throw error;
        }
    }
};
export default actions;
